import React from 'react';
import styles from './smsBubble.scss';
import { Picture, Img } from '@xo-union/tk-component-picture';

interface Props {
  message: string;
  imageId?: string;
  subtext?: string;
  color?: string;
}

export const SmsBubble: React.FC<Props> = ({ message, imageId, subtext, color = 'primary' }) => {
  return (
    <>
      {imageId ? (
        <div className={styles.smsMessagImg}>
          <Picture id={imageId} slug="cover-photo">
            <Img width={355} />
          </Picture>
          <div className={styles.smsWebsiteLink}>
            {message}
            <br />
            <span>{subtext}</span>
          </div>
        </div>
      ) : (
        <div className={color === 'secondary' ? styles.smsSecondaryBubble : styles.smsBubble}> {message} </div>
      )}
    </>
  );
};
